import Velocity from '../../../node_modules/velocity-animate/velocity';
import Hunt from 'huntjs';

// const $ = jQuery;

export function metric() {

    const metrics = document.querySelectorAll('.block__counter');

    new Hunt(metrics, {
        enter: (metricBlock) => {
            const targetValue = parseInt(metricBlock.getAttribute('data-value') || 99999, 10);
            const duration = parseInt(metricBlock.getAttribute('data-duration') || 2500, 10);
            const startValue = parseInt(metricBlock.getAttribute('data-start') || 0, 10)
            const kran = metricBlock.querySelector('svg');

            if (targetValue === 0) {

                Velocity(kran.querySelector('#seil'), { height: '-=12.1px' }, { duration });
                Velocity(kran.querySelector('#last'), { translateY: '-=12.1px' }, {
                    duration,
                    complete: (elements) => {
                        console.log(elements);
                        for (const element of elements) {
                            Velocity(element.querySelector('#count'),
                                { x: '+=9.5px' },
                                {
                                    duration: duration / 2,
                                    complete: () => {
                                        Velocity(kran.querySelector('#havana'), { height: '+15px' }, { duration: duration / 5 });
                                        // Velocity(kran.querySelector('#zapfhahn'), {
                                        //     rotateZ: 10
                                        // }, { duration: duration / 5 });
                                    }
                                })
                        }
                    }
                });

                Velocity(kran.querySelector('#count'), {
                    tween: [targetValue, startValue]
                }, {
                    duration: duration,
                    progress: (elements, c, r, s, tweenValue) => {
                        console.log(elements);
                        for (const e of elements) {
                            e.innerHTML = Math.round(tweenValue);
                        }
                    }
                })
            }
        }
    })
}